<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="container">
            <div class="grid grid-cols-3 md:grid-cols-6">
                <div class="text-xl font-bold col-span-3 md:col-span-2 mt-3">
                    {{ $t('sale.todayTradeAmount') }}
                </div>
                <div v-if="purchaseCurrency !== null" class="col-span-2 md:col-span-1 text-main font-bold text-xl ml-2 mt-3">
                    {{
                        getTotalPurchaseAmount()
                    }}
                </div>
                <div class="col-span-1 mt-3">
                    <b-form-select
                        class="border-0 mt-n1 focus:ring-0 w-20"
                        v-model="selectedCurrencyShortName">
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>
            </div>
            <SearchCollapse :is-bg-white="true" :do-action="showCheckbox" :show-collapse="isCollapsed">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                    <div class="md:col-span-3 btn-group btn-group-toggle flex justify-content-around" data-toggle="buttons">
                        <label class="btn btn-primary button-stat active font-bold flex align-items-center justify-content-center">
                            <input type="radio" v-model="search.isPayed" @click="search.isPayed = null" name="options" checked>{{ $t('filter.all') }}
                        </label>
                        <label class="btn btn-primary button-stat">
                            <input type="radio" v-model="search.isPayed" @click="search.isPayed = true" name="options">{{ $t('payed') }}
                        </label>
                        <label class="btn btn-primary button-stat">
                            <input type="radio" v-model="search.isPayed" @click="search.isPayed = false" name="options">{{ $t('onCredit') }}
                        </label>
                    </div>

                    <div class="md:col-span-1">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-9 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchSalesInfo">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-9 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetSaleSearchInfo">
                        </button>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 mt-3">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('person.givenName') }}
                        </div>
                        <b-form-input
                            v-model="search.personGivenName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('person.familyName') }}
                        </div>
                        <b-form-input
                            v-model="search.personFamilyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('person.additionalName') }}
                        </div>
                        <b-form-input
                            v-model="search.personAdditionalName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('company.title') }}
                        </div>
                        <b-form-input
                            v-model="search.companyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 mt-3">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.fromSum') }}
                        </div>
                        <b-form-input
                            v-model="search.sumMin"
                            class="focus:ring-0 border-gray-300 h-11"
                            type="number"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toSum') }}
                        </div>
                        <b-form-input
                            v-model="search.sumMax"
                            class="focus:ring-0 border-gray-300 h-11"
                            type="number"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.thisTime') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="after"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toTime') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="before"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>
                </div>
            </SearchCollapse>

        </div>

        <b-modal id="epos_print" size="xl" :title="$t('printView.printCheck')" hide-footer>
            <!-- Modal body -->
            <div id="epos_receipt">

            </div>
        </b-modal>

        <b-modal id="pay-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="payDebts">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$bvModal.hide('pay-modal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>
        <b-modal id="more-pay-modal" size="md" :title="$t('payDebt')" hide-footer>
            <!-- Modal body -->
            <div class="modal-body row">
                <div class="col-12 col-lg-4 font-bold">
                    <div>
                        {{ $t('selected') }}: {{ payDebtsSales.length }}
                    </div>
                    <div>
                        {{ $t('customer.title') }}:
                        <span v-for="(customer, index) of customers" :key="index" style="color: #46BDA1">
                                <span v-if="index !== 0">, </span>{{ customer }}</span>
                    </div>
                </div>
                <div class="col-12 col-lg-8">
                    <div class="row text-green-600 font-bold">
                        <div class="col-6">{{ $t('statistics.categories.totalSale') }}:</div>
                        <div class="col-6">{{ showCurrencyById(getUserCompany.baseCurrency.id, salesTotalPrice) }}</div>
                    </div>
                    <div class="row text-red-600 font-bold">
                        <div class="col-6">{{ $t('debtor.indebtedness') }}:</div>
                        <div class="col-6">{{ showCurrencyById(getUserCompany.baseCurrency.id, salesTotalDebts) }}</div>
                    </div>
                </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button
                    class="h-10 bg-denyColor hover:bg-hoverDenyColor rounded border-0 text-white"
                    @click="$bvModal.hide('more-pay-modal')"
                >
                    {{ $t('sale.transaction.cancel') }}
                </button>
                <button
                    class="h-10 bg-main hover:bg-hoverMain w-24 px-3 rounded border-0 text-white font-bold"
                    @click="payMoreDebts"
                >
                    {{ $t('pay') }}
                </button>
            </div>
        </b-modal>

        <table class="w-full mt-3">
            <thead class="bg-lightGray h-11">
            <tr class="text-center">
                <th class="" v-if="isCollapsed"></th>
                <th class="d-none d-lg-table-cell">{{ $t('printView.receipt') }}</th>
                <th class="d-none d-lg-table-cell">{{ $t('employee.cashier') }}</th>
                <th>{{ $t('totalPrice') }}</th>
                <th>{{ $t('customer.title') }}</th>
                <th class="d-none d-lg-table-cell">{{ $t('incomeAndOutcome.Status') }}</th>
                <th class="d-none d-sm-table-cell">{{ $t('date') }}</th>
                <th>{{ $t('actions') }}</th>
            </tr>
            </thead>
            <tbody v-for="sale of sales" :key="sale.id">
            <tr class="h-11 text-center">
                <td v-if="isCollapsed">
                        <span v-if="sale.isSelected">
                            <b-form-checkbox
                                v-if="isDebt(sale)"
                                class="d-inline"
                                size="lg"
                                :value="sale"
                                v-model="payDebtsSales"
                            ></b-form-checkbox>
                            <b-form-checkbox
                                v-else
                                class="d-inline"
                                size="lg"
                                :value="sale.id"
                                v-model="toDeleteSales"
                            ></b-form-checkbox>
                        </span>
                </td>

                <td class="d-none d-lg-table-cell"> {{ sale.id }}</td>
                <td class="d-none d-lg-table-cell text-main font-bold underline">
                    <router-link v-if="sale.employee" :to="$i18nHelper.getUrl('employee/' + sale.employee.id)">
                        {{ getEmployeeName(sale) }}
                    </router-link>
                </td>
                <td>{{ totalPrice(sale) }}</td>
                <td class="text-main font-bold underline">
                    <router-link :to="$i18nHelper.getUrl('customers/' + sale.customer.id)">
                        {{ getCustomerName(sale) }}
                    </router-link>
                </td>
                <td class="d-none d-lg-table-cell">
                   <div :style="{'background-color': howBgColor(sale)}" class="py-1 rounded w-36">{{ hasPayedText(sale) }}</div>
                </td>
                <td class="d-none d-sm-table-cell">{{ createdAt(sale) }}</td>
                <td>
                    <div class="d-flex">
                            <span
                                v-if="hasNotPayedCanceled"
                                class="pr-4"
                                style="color: #46BDA1; cursor: pointer;"
                                @click="showSaleAll(sale.id); oneSale = sale; calcDebtDay(sale); payDebt = null"
                            >
                                <img v-if="sale.id === saleId" src="/images/down-arrow-blue.png" class="h-2.5 mb-1" alt="down_arrow">
                                <img v-else src="/images/right-arrow%20-blue.png" class="h-2.5 mb-1" alt="down_arrow">
                            </span>

                        <img v-if="!sale.isCanceled" src="/images/edit.png" class="h-6 cursor-pointer" @click="editTransaction(sale)"  alt="down_arrow">
                    </div>
                </td>
            </tr>
            <tr v-if="sale.id === saleId && saleProductsAndServices.length > 0">
                <td></td>
                <td colspan="5">

                        <div class="mt-3 flex justify-content-between">
                            <div class="text-main">{{ $t('detailed') }}</div>
                            <div class="text-gray-500">
                                {{ $t('printView.receipt') }}{{ sale.id }}
                            </div>
                        </div>

                        <table class="w-full">
                            <thead class="h-10">
                            <tr class="text-center">
                                <th>{{ $t('product.title') }}</th>
                                <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                                <th>{{ $t('amount') }}</th>
                                <th>{{ $t('sale.sum') }}</th>
                            </tr>
                            </thead>
                            <tbody
                                v-for="(saleItem, index) in saleProductsAndServices"
                                :key="index"
                            >
                            <tr
                                :style="saleItem.updatedAt !== null ? 'background-color: #EE9BF5' : 'background-color: #fff; border-bottom: 1px solid #ECEFF6'"
                                v-if="saleItem['@type'] === 'SaleProduct'"
                                class="h-10 text-center"
                            >
                                <td> {{ saleItem.product.name }}</td>
                                <td class="d-none d-sm-table-cell">
                                    {{ showPrice(saleItem) }}
                                </td>
                                <td>
                                    {{
                                        parseFloat(saleItem.amount) + ' ' + showUnitOfMeasure(saleItem.product.unitOfMeasure)
                                    }}
                                </td>
                                <td>{{ showCurrencyById(sale.currency.id, saleItem.price) }}</td>
                            </tr>
                            <tr
                                :style="saleItem.updatedAt !== null ? 'background-color: #EE9BF5' : 'background-color: #fff; border-bottom: 1px solid #ECEFF6'"
                                v-else
                                class="h-10 text-center"
                            >
                                <td> {{ saleItem.service.name }}
                                    <span class="text-xs">{{' ' + '(' + $t('service.title') + ')'}}</span>
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ parseFloat(saleItem.price) / parseFloat(saleItem.amount) }}
                                </td>
                                <td>
                                    {{
                                        parseInt(saleItem.amount)
                                    }}
                                </td>
                                <td>{{ showCurrencyById(sale.currency.id, saleItem.price) }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="col-12 d-sm-inline">
                            <Row class="mx-md-5 my-md-2">
                                <div class="col-12">
                                    <span class="float-left font-bold">{{ $t('payedAmount') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(
                                                getSale.currency.id,
                                                parseFloat(sale.totalPurchaseAmount > 0 ? sale.totalPurchaseAmount : sale.totalPrice))
                                        }}</span>
                                </div>

                                <div v-if="sale.bonusSumAmount > 0" class="col-12">
                                    <span class="float-left font-bold">{{ $t('sale.discount.title') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, parseFloat(sale.bonusSumAmount ? sale.bonusSumAmount : '0'))
                                        }}</span>
                                </div>

                                <div v-if="sale.bonusPercentAmount > 0" class="col-12">
                                    <span class="float-left font-bold">{{ $t('sale.discount.title') }}</span>

                                    <span
                                        class="float-right">{{
                                            sale.discountPercent + '% = ' + showCurrencyById(sale.currency.id, parseFloat(sale.bonusPercentAmount))
                                        }}</span>
                                </div>

                                <div v-if="sale.isTaxInPrice" class="col-12">
                                        <span class="float-left font-bold">
                                             {{ $t('sale.tax.inPriceOnCheck') }}
                                            {{ $t('sale.tax.title') }}
                                        </span>
                                    <span class="float-right">
                                            {{ getTaxAmount(sale) }}
                                        </span>
                                </div>

                                <div v-else class="col-12">
                                    <span class="float-left font-bold">{{ $t('sale.tax.title') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(
                                                getSale.currency.id,
                                                parseFloat(sale.totalPurchaseAmount) - (parseFloat(sale.totalPrice) + parseFloat(sale.bonusSumAmount)))
                                        }}</span>
                                </div>

                                <div class="col-12" v-if="parseInt(sale.cashback) > 0">
                                    <span class="float-left font-bold">{{ $t('customer.cashback.payFromCashback') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, sale.cashback)
                                        }}</span>
                                </div>

                                <div class="col-12">
                                    <span class="float-left font-bold">{{ $t('payed') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, sale.payedAmount - sale.cashback)
                                        }}</span>
                                </div>
                                <div class="col-12 p-0">
                                    <hr/>
                                </div>

                                <div class="col-12" v-if="!sale.isPayed && sale.totalPrice - sale.payedAmount > 0">
                                    <span class="float-left font-bold">{{ $t('productPurchase.paymentDate') }}</span>
                                    <span class="float-right" data-toggle="tooltip" data-placement="right"
                                          style="cursor: pointer"
                                          :style="getColor()"
                                          :title="getTooltipText()"
                                    >
                                            {{ dateFormat(sale.repaymentDate) }}
                                        </span>
                                </div>
                                <div class="col-12" v-if="sale.totalPrice - sale.payedAmount > 0">
                                    <span class="float-left font-bold">{{ $t('debt') }}</span>
                                    <span
                                        class="float-right">{{
                                            showCurrencyById(sale.currency.id, sale.totalPurchaseAmount - sale.payedAmount - sale.bonusSumAmount)
                                        }}</span>
                                </div>

                                <div class="col-12" v-if="!sale.isCanceled && sale.transaction === null">
                                    <div class="d-flex">
                                        <span class="flex-fill font-bold">{{ $t('payDebt') }}</span>
                                        <div class="col-6 d-flex form-control border-gray-700 py-1">
                                            <input
                                                class="col-12 col-sm-7 col-lg-8 border-0 outline-none"
                                                v-model="payDebt"
                                                type="number"
                                                min="0"
                                                @input="changeInput"
                                            />
                                            <ButtonTag
                                                class="d-none  col-sm-5 col-lg-4 pb-4 pt-0 mb-1 d-sm-flex"
                                                :is-w100="true"
                                                :type="'button'"
                                                :size="'md'"
                                                :is-disabled="isMore"
                                                :do-action="clickButton"
                                            >
                                                {{ $t('filter.all') }}
                                            </ButtonTag>
                                        </div>
                                        <button
                                            type="submit"
                                            class="text-white bg-main hover:bg-hoverMain w-32 h-9 rounded ml-2 cursor-pointer"
                                            :disabled="!isMore"
                                            v-on:click.prevent="$bvModal.show('pay-modal')"
                                        >
                                                    <span v-show="isLoading" class="spinner-border spinner-border-sm"
                                                          role="status"
                                                          aria-hidden="true"></span>
                                            {{ $t('pay') }}
                                        </button>
                                    </div>
                                </div>
                                <RowColumn v-if="sale.paymentHistory.length > 0" class="col-12 m-0 p-0 my-4">
                                    <CurrencyCollapse button-name="productPurchase.paymentHistory" :is-bg-white="true">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>{{ $t('productPurchase.paymentAmount') }}</th>
                                                <th>{{ $t('date') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in reverse(sale.paymentHistory)"
                                                v-bind:key="index">
                                                <td>{{ showCurrencyById(sale.currency.id, item.payment) }}</td>
                                                <td>{{ dateTimeFormat(item.createdAt) }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </CurrencyCollapse>
                                </RowColumn>
                            </Row>
                        </div>

                        <Row class="pb-3" v-if="sale.description !== '' && sale.description !== null">
                            <div class="col-12 col-md-6">
                                <div>{{ $t('additionalInformation') }}</div>
                                <span class="d-flex border pl-1" style="color: #6c757d">{{sale.description}}</span>
                            </div>
                        </Row>

                        <div class="mb-2 col-12 d-block">
                            <TextTag class="text-hoverDenyColor font-bold" v-if="sale.isCanceled">{{
                                    $t('sale.transaction.canceled')
                                }}
                            </TextTag>

                            <button
                                v-else
                                @click="canceledSale"
                                class="w-48 bg-denyColor h-10 text-white rounded hover:bg-hoverDenyColor border-0 focus:outline-none">
                                {{ $t('sale.transaction.cancel') }}
                            </button>


                            <div class="flex float-right mt-3 mt-sm-0">

                                <div  v-if="lastSaleId === sale.id" class="group w-10 cursor-pointer mx-3">
                                    <span class="group-hover:opacity-100 bottom-10 bg-gray-800 px-1 text-sm text-gray-100 rounded absolute opacity-0">{{ $t('printView.printEpos') }}</span>
                                    <img src="/images/receipt.png" @click="printEpos" alt="" class="h-10">
                                </div>

                                <div class="group w-10 cursor-pointer mx-3">
                                    <span class="group-hover:opacity-100 bottom-10 bg-gray-800 px-1 text-sm text-gray-100 rounded absolute opacity-0">{{ $t('printView.printCheck') }}</span>
                                    <img src="/images/invoice.png" @click="printCheck" alt="" class="h-10">
                                </div>

                                <div class="group w-10 cursor-pointer mx-3">
                                    <span class="group-hover:opacity-100 bottom-10 bg-gray-800 px-1 text-sm text-gray-100 rounded absolute opacity-0">{{ $t('printView.printA4') }}</span>
                                    <img src="/images/invoice%20(1).png" @click="printA4" alt="" class="h-10">
                                </div>
                            </div>
                        </div>
                </td>
            </tr>
            </tbody>
        </table>

        <div class="grid grid-cols-12 mt-3 container">
            <div class="col-span-12 col-start-1 md:col-span-2">
                <button
                    class="bg-denyColor rounded w-full border-0 text-white font-bold h-11 hover:bg-hoverDenyColor focus:ring-0"
                    v-if="toDeleteSales.length > 0"
                    @click="showModal"
                >
                    {{ $t('delete') }}
                </button>
            </div>
            <div class="col-span-12 md:col-start-11 md:col-span-2">
                <button
                    class="bg-denyColor rounded w-full border-0 text-white font-bold h-11 hover:bg-hoverDenyColor focus:ring-0"
                    v-if="payDebtsSales.length > 0"
                    @click="showModalPayDebts"
                >
                    {{ $t('payDebt') }}
                </button>
            </div>

        </div>
        <RowColumn class="mt-3 ml-3 pb-4">
            <Pagination
                :search="search"
                base-url="sales/transactions"
                :total-items="getSalesTotalCount"
                method-name="searchSalesTransactions"/>
        </RowColumn>

        <b-modal class="modal fade" id="myModal" hide-header hide-footer hide-header-close>
            <h4 class="modal-title">{{ $t('warning') }}!</h4>

            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('sale.editSaleWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn danger" data-dismiss="modal" @click="cancel()">
                    {{ $t('yes') }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$bvModal.hide('myModal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

        <b-modal id="delete-sale-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('sale.deleteSaleWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn danger" data-dismiss="modal" @click="deleteSales">
                    {{ $t('yes') }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="cancelDelete">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>
    </Row>
</template>

<script>
import RowColumn from "../../components/RowColumn";
import Pagination from "../../components/html/Pagination";
import {mapActions, mapGetters, mapMutations} from "vuex";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormatting from "../../mixin/dateFormattingMixin";
import SearchCollapse from "../../components/SearchCollapse";
import accessMixin from "@/mixin/accessMixin";
import TextTag from "@/components/html/TextTag";
import ButtonTag from "@/components/html/ButtonTag";
import Row from "@/components/html/Row";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import CurrencyCollapse from "@/components/CurrencyCollapse.vue";
import InputBox from "@/components/InputBox.vue";

export default {
    name: "List",
    components: {
        InputBox,
        CurrencyCollapse,
        Row,
        ButtonTag,
        TextTag,
        Pagination,
        RowColumn,
        SearchCollapse
    },
    mixins: [currencyFormatMixin, currencyRateMixin, dateFormatting, accessMixin],
    data() {
        return {
            saleProductsAndServices: [],
            purchaseCurrency: null,
            selectedCurrencyShortName: 'UZS',
            sales: [],
            saleId: 0,
            lastSaleId: null,
            customers: [],
            salesTotalPrice: 0.0,
            salesTotalDebts: 0.0,
            isCollapsed: false,
            item: {id: null, isCanceled: false},
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'sale.title', url: 'sales/sale'},
                {name: 'transactions'},
            ],
            search: {
                personGivenName: '',
                personFamilyName: '',
                personAdditionalName: '',
                companyName: '',
                isPayed: null,
                after: '',
                before: '',
                sumMin: '',
                sumMax: '',
                page: 1,
                id: null
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            isShowCheckbox: false,
            toDeleteSales: [],
            selectedSales: [],
            payDebtsSales: [],
            isCheckedAll: false,
            currentDate: '',
            baseCurrency: '',
            payDebt: null,
            totalDebt: 0,
            sumDebt: 0,
            isMore: false,
            isLoading: false,
            oneSale: {},
            prevRoute: null,
            debtDay: 0
        }
    },
    computed: {
        ...mapGetters([
            'getTodaySalesTotalAmount',
            'getSalesTotalCount',
            'getAllSales',
            'getSales',
            'getSale',
            'getUserRoles',
            'getUserCompany',
            'getNewSaleId',
            'getCurrency',
            'getEpos'
        ]),
        currentPage() {
            let page = this.$route.params.page

            if (page === undefined) {
                return 1
            }

            return page
        },
    },
    methods: {
        ...mapActions([
            'searchSales',
            'fetchAllSales',
            'pushSaleCancel',
            'deleteSale',
            'fetchSales',
            'fetchSale',
            'fetchUser',
            'fetchUpdateSalePayment',
            'pushMakePayed',
            'fetchTodaySalesTotalAmount',
            'searchSalesTransactions',
            'setBreadcrumbItems'
        ]),
        ...mapMutations(['updateNewSaleId']),
        editTransaction(sale) {
            this.setId(sale)
            this.$bvModal.show('myModal')
        },
        getTooltipText() {
            return this.debtDay > 0 ?
                this.$t('debtPayingTimeNotCome') :
                this.debtDay === 0 ? this.$t('debtPayingTimeCome') :
                    this.$t('debtPayingTimeGone')
        },
        getTaxAmount(sale) {
            let tax = this.getUserCompany.tax

            if (tax === null) {
                return ''
            }

            return this.showCurrencyById(
                this.getSale.currency.id,
                    this.getTaxInPriceAmount(sale.totalPurchaseAmount, tax.percent)
            )
        },
        getTaxInPriceAmount(amount, percent) {
            return amount * parseFloat(percent) / 100
        },
        getColor() {
            return this.debtDay > 5 ? 'color: green' : this.debtDay >= 0 ? 'color: #ea4d5c' : 'color: red'
        },
        calcDebtDay(sale) {
            const time = new Date(sale.repaymentDate) - Date.now();
            this.debtDay = Math.ceil(Math.ceil((time / 1000) / (3600 * 24)));
        },
        reverse(value) {
            return value.slice().reverse()
        },
        getTotalPurchaseAmount() {
            if (this.purchaseCurrency === null) {
                this.purchaseCurrency = this.getCurrency(this.getTodaySalesTotalAmount.currency.id)
            }

            let totalPrice = this.calculateAmountByBaseCurrency(
                this.getTodaySalesTotalAmount.amount,
                this.purchaseCurrency.shortName,
                this.selectedCurrencyShortName
            )

            return this.showCurrencyWithoutSymbol(
                this.getCurrencyByShortName(this.selectedCurrencyShortName),
                totalPrice
            )
        },
        calculateReversePercentAmount(amount, percent) {
            if (percent === null) {
                percent = 0
            }

            return amount * 100 / (100 - percent)
        },
        showPrice(saleProduct) {
            if (saleProduct.price === "0.0000") {
                return 0
            }

            let isBonus = false
            let isPercent = false
            let percent = 0

            // let data = this.oneSale ? this.oneSale : this.getSale
            let data = this.getSale

            data.discount.find(d => {
                if (
                    d.discount.discountType === 'product' &&
                    this.isSaleProductBonus(d, saleProduct)
                ) {
                    return isBonus = true
                } else if (d.discount.discountType === 'percent') {
                    if (
                        !d.discount.isForAllProducts &&
                        d.discount.discountProducts.find(dp => !dp.isBonus && dp.product.id === saleProduct.product.id) !== undefined
                    ) {
                        percent = d.discount.discountPercent
                        return isPercent = true
                    }
                }
            })

            if (isBonus) {
                return this.$t('sale.discount.discountProduct')
            }

            if (isPercent) {
                return this.showCurrencyByIdWithoutSymbol(
                        data.currency.id,
                        this.calculateReversePercentAmount(saleProduct.price, percent) / saleProduct.amount
                    ) + ' - ' + percent + '% = ' +
                    this.showCurrencyByIdWithoutSymbol(
                        data.currency.id,
                        saleProduct.price / saleProduct.amount
                    )
            }

            return this.showCurrencyByIdWithoutSymbol(data.currency.id, saleProduct.price / saleProduct.amount)
        },
        isSaleProductBonus(discount, saleProduct) {
            return discount.discount.discountProducts.find(
                dp => dp.isBonus &&
                    dp.product.id === saleProduct.product.id &&
                    parseFloat(saleProduct.price) === 0.0
            ) !== undefined
        },
        clickButton() {
            this.$bvModal.show('pay-modal')
            this.payDebt = this.oneSale.totalPurchaseAmount - this.oneSale.payedAmount - this.oneSale.bonusSumAmount
        },
        payDebts() {
            this.$bvModal.hide('pay-modal')
            this.$root.showOverlay = true
            let amount = ((+this.payDebt) + (+this.oneSale.payedAmount)).toString()

            if ((parseFloat(amount) + parseFloat(this.oneSale.bonusSumAmount)) === parseFloat(this.oneSale.totalPurchaseAmount)) {
                this.pushMakePayed({id: this.oneSale.id})
                    .then(() => {
                        this.fetchUpdateSalePayment({
                            id: this.getSale.id,
                            payedAmount: this.getSale.totalPurchaseAmount,
                            paymentAmount: +this.payDebt,
                            debt: '0.0000',
                            debtHistory:
                                {
                                    payment: this.payDebt.toString()
                                }
                        })
                            .then((res) => {
                                this.oneSale = res
                                this.payDebt = null
                                this.updateSales()
                            })
                            .catch(() => {
                                this.$root.showOverlay = false
                            })
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.fetchUpdateSalePayment({
                    id: this.oneSale.id,
                    payedAmount: amount,
                    paymentAmount: +this.payDebt,
                    debt: (this.oneSale.totalPurchaseAmount - (+(this.payDebt) + (+this.oneSale.payedAmount))).toString(),
                    debtHistory:
                        {
                            payment: this.payDebt.toString(),
                        }
                })
                    .then((res) => {
                        this.updateSales()
                        this.oneSale = res
                        this.payDebt = null
                    })
            }
        },
        payMoreDebts() {
            this.$bvModal.hide('more-pay-modal')
            this.$root.showOverlay = true

            for (let sale of this.payDebtsSales) {
                this.pushMakePayed({id: sale.id})
                    .then(() => {
                        this.fetchUpdateSalePayment({
                            id: sale.id,
                            payedAmount: sale.totalPrice,
                            debt: '0.0000',
                            debtHistory:
                                {
                                    payment: (parseFloat(sale.totalPrice) - parseFloat(sale.payedAmount)).toString(),
                                }
                        })
                    })
            }

            this.updateSales()
            this.$i18nHelper.flash(this.$t('debtor.debtSuccessPaid'), 'success')
            this.payDebtsSales = []
            this.$root.showOverlay = false
        },
        findCustomerName() {
            this.salesTotalPrice = 0.0
            this.salesTotalDebts = 0.0
            this.customers = []
            let customersName = []

            for (let sale of this.payDebtsSales) {
                customersName.push(this.getCustomerName(sale))
                this.salesTotalPrice += this.calculateAmountByBaseCurrency(sale.totalPrice, sale.currency.shortName, this.baseCurrencyShortName)
                this.salesTotalDebts += this.calculateAmountByBaseCurrency(sale.totalPrice - sale.payedAmount, sale.currency.shortName, this.baseCurrencyShortName)
            }

            this.customers = [...new Set(customersName)];
        },
        changeInput() {
            this.isMore = parseInt(this.payDebt) > parseInt(this.sumDebt);
        },
        printEpos() {
            this.$bvModal.show('epos_print')

            setTimeout(() => {
                let obj = document.createElement('object')
                obj.style.width = '100%'
                obj.style.height = '582pt'
                obj.type = 'application/pdf'
                obj.data = 'data:application/pdf;base64,' + this.getEpos.paycheck
                let myDiv = document.getElementById('epos_receipt')
                myDiv.appendChild(obj)
            }, 200)
        },
        printA4() {
            this.$i18nHelper.toUrl('sales/transactions/' + this.getSale.id + '/print')
        },
        printCheck() {
            this.$i18nHelper.toUrl('sales/transactions/' + this.getSale.id + '/check-print')
        },
        canceledSale() {
            this.$root.showOverlay = true
            let data = {id: this.oneSale.id}

            this.pushSaleCancel(data)
                .then(() => {
                    this.searchSalesTransactions({page: this.currentPage, isSearch: false})
                    this.fetchSale(this.oneSale.id)
                        .then(() => {
                            this.$root.showOverlay = false
                        })
                })
                .catch(() => {
                    this.$root.showOverlay = false
                })
        },
        showSaleAll(id) {
            if (this.saleId === id) {
                this.saleId = 0
            } else {
                this.saleId = id
                this.fetchSale(id)
                    .then(() => {
                        this.saleProductsAndServices = this.getSale.saleProducts.concat(this.getSale.saleServices)
                    })
            }
        },
        showCheckbox() {
            this.isCollapsed = !this.isCollapsed

            if (!this.isCollapsed) {
                this.toDeleteSales = []
                this.isSelectedAll = false
            }
        },
        isDebt(sale) {
            return !(sale.totalPurchaseAmount === sale.payedAmount || sale.isCanceled);
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        setId(product) {
            this.item.id = product.id
            this.item.isCanceled = product.isCanceled
            this.$bvModal.hide('myModal')
        },
        showModal() {
            if (this.toDeleteSales.length > 0) {
                this.$bvModal.show('delete-sale-modal')
            }
        },
        showModalPayDebts() {
            if (this.payDebtsSales.length > 0) {
                this.findCustomerName()
                this.$bvModal.show('more-pay-modal')
            }
        },
        async deleteSalesAction() {
            this.toDeleteSales.forEach(sale => {
                console.log(sale)
                this.deleteSale(sale)
            })
        },
        deleteSales() {
            this.$root.showOverlay = true

            this.deleteSalesAction()
                .then(() => {
                    this.toDeleteSales = []
                    this.$bvModal.hide('delete-sale-modal')
                    this.isCheckedAll = false
                })
                .finally(() => {
                    setTimeout(this.updateSales, 1000)
                })
        },
        updateSales() {
            this
                .searchSalesTransactions(this.search)
                .then(() => {
                    this.$root.showOverlay = false
                })
                .catch(() => {
                    this.$root.showOverlay = false
                })
        },
        cancelDelete() {
            this.$bvModal.hide('delete-sale-modal')
            this.toDeleteSales = []
            this.isCheckedAll = false
        },
        cancel() {
            this.$root.showOverlay = true

            if (!this.item.isCanceled) {
                this.pushSaleCancel({id: this.item.id})
                    .then(() => {
                        this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
                        this.$i18nHelper.toUrl('sales/edit/' + this.item.id);
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.$i18nHelper.toUrl('sales/edit/' + this.item.id);
            }
        },
        searchSalesInfo() {
            let url = ''
            url += this.search.personGivenName ? 'personGivenName=' + this.search.personGivenName + '&' : ''
            url += this.search.personFamilyName ? 'personFamilyName=' + this.search.personFamilyName + '&' : ''
            url += this.search.personAdditionalName ? 'personAdditionalName=' + this.search.personAdditionalName + '&' : ''
            url += this.search.companyName ? 'companyName=' + this.search.companyName + '&' : ''
            url += this.search.isPayed !== null ? 'isPayed=' + this.search.isPayed + '&' : ''
            url += this.search.after ? 'after=' + this.search.after + '&' : ''
            url += this.search.before ? 'before' + this.search.before + '&' : ''
            url += this.search.sumMin ? 'sumMin' + this.search.sumMin + '&' : ''
            url += this.search.sumMax ? 'sumMax=' + this.search.sumMax + '&' : ''
            url += this.search.page !== 1 ? 'page=' + this.search.page + '&' : ''

            if (this.$route.fullPath + '&' !== this.$i18nHelper.getUrl('sales/transactions?' + url)) {
                this.$i18nHelper.toUrl('sales/transactions?' + url)
            }
        },
        resetSaleSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSalesInfo()
        },
        isBgColorWarning(item) {
            return this.hasNotPayed(item)
        },
        isBgColorDanger(item) {
            return this.hasNotPayedCanceled(item)
        },
        totalPrice(item) {
            return this.showCurrencyById(item.currency.id, item.totalPurchaseAmount)
        },
        getCustomerName(item) {
            return item.customer.isCompany ?
                item.customer.customerCompany.name :
                item.customer.person.givenName + ' ' + item.customer.person.familyName
        },
        getEmployeeName(item) {
            return item.employee.givenName
        },
        hasNotPayed(item) {
            return item.transaction === null
        },
        hasNotPayedCanceled(item) {
            return item.isCanceled === true
        },
        hasPayedText(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? this.$t('sale.transaction.canceled') : this.$t('payed')
            }

            return this.hasNotPayed(item) ? this.$t('statistics.categories.debt') : this.$t('payed')
        },
        howBgColor(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? '#FFC9D9' : '#FFF'
            }

            return this.hasNotPayed(item) ? '#FFCDB8' : '#D4F8E5'
        },
        createdAt(item) {
            return this.dateTimeFormat(item.createdAt, true)
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.isSelectedAll = false
                this.isCheckedAll = false
                this.toDeleteSales = []
            }
        },
        'prevRoute.name'() {
            if (this.prevRoute.name === 'sales/newSale') {
                this.showSaleAll(this.getNewSaleId)
                this.oneSale = this.getSales[this.getNewSaleId]
            }
        },
        toDeleteSales() {
            if (this.toDeleteSales.length > 0) {
                for (let sale of this.sales) {
                    if (sale.totalPurchaseAmount !== sale.payedAmount && !sale.isCanceled) {
                        sale.isSelected = false
                    } else {
                        sale.isSelected = true
                    }
                }
            } else {
                for (let sale of this.sales) {
                    sale.isSelected = true
                }
            }
        },
        payDebtsSales() {
            if (this.payDebtsSales.length > 0) {
                for (let sale of this.sales) {
                    if (sale.totalPurchaseAmount === sale.payedAmount || sale.isCanceled) {
                        sale.isSelected = false
                    } else {
                        sale.isSelected = true
                    }
                }
            } else {
                for (let sale of this.sales) {
                    sale.isSelected = true
                }
            }
        },
        getSales() {
            this.sales = [];

            for (let sale of this.getSales) {
                sale.isSelected = true;
                this.sales.push(sale)
            }
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    beforeMount() {
        if (Object.keys(this.$route.query).length > 0) {
            if (this.$route.query['id'] === undefined) {
                this.saleId = this.$route.query['id']
            }

            let keys = Object.keys(this.$route.query)

            keys.map(key => {
                this.search[key] = this.$route.query[key]
            })

            this.isCollapsed = true
            this.$root.showOverlay = true
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    mounted() {
        this.fetchTodaySalesTotalAmount()
            .then(() => {
                if (this.getNewSaleId !== null) {
                    this.saleId = this.getNewSaleId

                    this.fetchSale(this.getNewSaleId)
                        .then(() => {
                            this.saleProductsAndServices = this.getSale.saleProducts.concat(this.getSale.saleServices)
                        })
                }

                if (this.saleId !== 0) {
                    this.oneSale = this.getSales.find(s => s.id)
                }

                if (this.getSales.length === 0) {
                    this.fetchSales(1)
                        .then(() => {
                            this.lastSaleId = this.getSales[0].id
                        })
                } else {
                    this.lastSaleId = this.getSales[0].id
                }

                this.purchaseCurrency = this.getCurrency(this.getTodaySalesTotalAmount.currency.id)
                this.selectedCurrencyShortName = this.purchaseCurrency.shortName
            })

    },
    beforeDestroy() {
        this.updateNewSaleId(null)
    },
}
</script>
<style scoped>


table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    height: 35px;
    width: 100px;
}

.button-stat:checked:active:focus {
    background-color: #6539B2 !important;
}

.button-stat:active {
    background-color: #6539B2 !important;
}


.danger {
    background-color: #bd2130;
    border-color: #bd2130;
    color: white;
}

.danger:hover {
    background-color: red;
    border-color: red;
}

.btn-secondary {
    background-color: #ffffff !important;
    border: none;
    padding: 0;
}

.select-all {
    font-size: 16px;
    margin-top: 5px;
}

.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

.col-1, .col-11 {
    padding: 0 !important;
}

.clear {
    clear: both;
}

@media only screen and (max-width: 845px) {
    ::placeholder {
        font-size: 15px;
    }
}

@media only screen and (max-width: 370px) {
    .date {
        font-size: 14px;
    }
}

.indicator-title {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}

.indicator-total {
    font-size: 18px;
    font-weight: 700;
    color: #8300C5;
}

.indicator {
    border-right: #444444 solid 1px;
    background-color: #F0EEF9;
    padding: 10px 0 10px 20px;
    margin: 1px 0;
}

.padding {
    padding-left: 0.75rem;
    padding-bottom: 0.75rem;
}

button {
    //width: 100px;
}
</style>
